import { Validator } from 'vee-validate'
import PasswordRule from './rules/password'
import CheckedRule from './rules/checked'
import BirthDateRule from './rules/birthdate'
import DateIsoRule from './rules/dateIso'

Validator.extend(
  PasswordRule.name,
  PasswordRule.validator
)

Validator.extend(
  CheckedRule.name,
  CheckedRule.validator
)

Validator.extend(
  BirthDateRule.name,
  BirthDateRule.validator
)

Validator.extend(
  DateIsoRule.name,
  DateIsoRule.validator
)

export default Validator
